import * as LJS from '../lib/littlejs.esm.js';
import { init, update, updatePost, render, renderPost } from './scenes/game.ts';
import { init as menuInit, update as menuUpdate, updatePost as menuUpdatePost, render as menuRender, renderPost as menuRenderPost } from './scenes/menu.ts';
import { tilesets } from './const/tiles.ts';
import ldtkData from '../assets/levels.ldtk';
import Globals from './globals.ts';
import GameOver from './gameover.ts';
import { Random } from './utils/random.ts';
import { getCenterTextPos } from './utils/font.ts';
// Configure engine options, disable splash screen and debug
LJS.setShowSplashScreen(false);
LJS.setDebugKey("None");
LJS.setShowWatermark(false);
// Fix texture bleeding by shrinking tile slightly
LJS.setTileFixBleedScale(.5);
LJS.setFontDefault('monospace');
let gameState = 'menu';
// Make gameState accessible globally for entity checks
Globals.gameState = gameState;
let levels = ldtkData.levels;
let currentLevelIndex = 0;
let levelCompleteTimer = 0;
let levelStartTimer = 0;
let isPaused = false;
let pauseMenuSelected = 0; // 0: Resume, 1: Restart Level, 2: Menu
let pauseKeyCooldown = 0;
function loadLevel(levelIndex) {
    const level = levels[levelIndex];
    Globals.rand = new Random(123456);
    init(level);
}
const TILESIZE = 16;
function engineInit() {
    menuInit();
}
function engineUpdate() {
    if (Globals.gameState === 'game') {
        // Only update game logic if not in levelStart state
        update();
    }
    else if (Globals.gameState === 'menu') {
        const action = menuUpdate();
        if (typeof action === 'object' && 'levelIndex' in action) {
            Globals.gameState = 'game';
            currentLevelIndex = action.levelIndex;
            loadLevel(currentLevelIndex);
        }
    }
}
function engineUpdatePost() {
    if (Globals.gameState === 'game') {
        // Only allow pause controls during actual gameplay, not during levelStart
        // Check for pause keys in updatePost too (always check)
        if (pauseKeyCooldown <= 0 && (LJS.keyWasPressed('Escape') || LJS.keyWasPressed('KeyP'))) { // Escape or P
            isPaused = !isPaused;
            LJS.setPaused(isPaused);
            pauseKeyCooldown = 10; // Prevent immediate re-triggering
            if (isPaused) {
                pauseMenuSelected = 0; // Reset to first option when pausing
            }
        }
        // Decrement cooldown
        if (pauseKeyCooldown > 0) {
            pauseKeyCooldown--;
        }
        if (!isPaused) {
            updatePost();
        }
        else {
            // Handle pause menu input in updatePost when paused
            if (LJS.keyWasPressed('ArrowUp')) { // Up arrow
                const oldSelected = pauseMenuSelected;
                pauseMenuSelected = Math.max(0, pauseMenuSelected - 1);
            }
            if (LJS.keyWasPressed('ArrowDown')) { // Down arrow
                const oldSelected = pauseMenuSelected;
                pauseMenuSelected = Math.min(2, pauseMenuSelected + 1);
            }
            if (LJS.keyWasPressed('Space')) { // Enter or Space
                if (pauseMenuSelected === 0) { // Resume
                    isPaused = false;
                    LJS.setPaused(false);
                    Globals.player.jumpTimer = 15;
                }
            }
        }
    }
    else if (Globals.gameState === 'gameOver') {
        if (LJS.keyWasPressed(' ') || LJS.keyWasPressed('Space')) {
            // Restart the game
            Globals.gameState = 'game';
            Globals.depth = 0;
            Globals.lastGenerated = 0;
            Globals.generationDepth = 0;
            Globals.descentSpeed = Globals.START_DESCENT_SPEED;
            Globals.rand = new Random(123456); // We instanciate a new Random to have the same seed
            loadLevel(currentLevelIndex);
        }
    }
    else {
        menuUpdatePost();
    }
}
function engineRender() {
    if (Globals.gameState === 'game') {
        render();
    }
    else if (Globals.gameState == 'menu') {
        menuRender();
    }
}
function engineRenderPost() {
    let font = new LJS.FontImage;
    if (Globals.gameState === 'game') {
        if (isPaused) {
            // Render pause overlay
            LJS.drawRect(LJS.mainCanvasSize.scale(0.5), LJS.mainCanvasSize, Globals.BLACK, 0, true, true);
            // Render pause menu using drawTextScreen
            const centerY = LJS.mainCanvasSize.y / 2;
            let pauseText = "PAUSE";
            let pauseX = getCenterTextPos(pauseText, 4);
            font.drawTextScreen(pauseText, LJS.vec2(pauseX, LJS.mainCanvasSize.y / 2), 4);
            let resumeText = "Press SPACE to resume";
            let resumeX = getCenterTextPos(resumeText, 2);
            font.drawTextScreen(resumeText, LJS.vec2(resumeX, LJS.mainCanvasSize.y - 80), 2);
        }
        else {
            renderPost();
        }
    }
    else if (Globals.gameState === 'gameOver') {
        GameOver.render();
    }
    else {
        menuRenderPost();
    }
}
// Launch engine
LJS.engineInit(engineInit, engineUpdate, engineUpdatePost, engineRender, engineRenderPost, tilesets);
